// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3juZX","content":"styles_content__1ETaM","wrapper":"styles_wrapper__1kg-v"};